<div class="d-flex flex-grow-1">
  <input type="checkbox" [formControl]="formControl" />
  <span>{{ label }}</span>
</div>
